import styled from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';

export const Body = styled(Flex)`
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(4, 0)};
`;

export const BodyContainer = styled(Box)`
  max-width: 450px;
  justify-content: center;
`;

export const CembraBenefitList = styled.ul`
  list-style: disc;
  margin-left: ${({ theme }) => theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;
